<template>
  <BlackFridayItem
    :class="[
      'border-static-default-low rounded-lg border-[0.5px] p-8 motion-safe:transition-all motion-safe:duration-300',
      isModalOpen
        ? 'bg-action-default-min-hover shadow-middle'
        : 'hover:bg-action-default-min-hover hover:shadow-middle',
    ]"
  >
    <template #icon>
      <IconPriceTagFilled />
    </template>
    <template #content>
      <div class="w-full">
        <button
          class="flex w-full items-center justify-between text-left"
          @click="openBlackFridaySpecialModal"
        >
          <span class="body-2-bold flex flex-col">
            {{ i18n(translations.title) }}
            <span class="caption flex flex-row items-center gap-4"
              >{{ i18n(translations.about) }}
              <RevTag
                :label="i18n(translations.tag)"
                size="small"
                variant="primary"
              />
            </span>
          </span>

          <IconChevronRight />
        </button>
      </div>
      <BlackFridaySpecialModal @close="isModalOpen = false" />
    </template>
  </BlackFridayItem>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { openModal } from '@ds/components/ModalBase'
import { RevTag } from '@ds/components/Tag'
import { IconChevronRight } from '@ds/icons/IconChevronRight'
import { IconPriceTagFilled } from '@ds/icons/IconPriceTagFilled'

import { MODAL_NAMES } from '~/scopes/product/pages/Product-JP/Product-JP.constants'

import translations from './BlackFridaySpecial.translations'
import BlackFridayItem from './components/BlackFridayItem/BlackFridayItem.vue'
import BlackFridaySpecialModal from './components/BlackFridaySpecialModal/BlackFridaySpecialModal.vue'

const i18n = useI18n()
const isModalOpen = ref(false)

const openBlackFridaySpecialModal = () => {
  isModalOpen.value = true
  openModal(MODAL_NAMES.BLACK_FRIDAY_SPECIAL_JP)
}
</script>
